import { MathFormula } from './Math';

export const VpsGravityType =
{
    Density: 1,
    SG: 2,
    API: 3,
}

export const VpsEnergyUnit =
{
    MJ_kg: 1,
    BTU_lb: 2,
    kCal_kg: 3,
    BTU_gal: 4,
    BTU_bbl: 5
}

export const VpsVolumeUnit =
{
    CubicMetres: 1,
    Barrels: 2,
    USGallons: 3
}

export const VpsQuantityUnit =
{
    CubicMetres: 1,
    Barrels: 2,
    USGallons: 3,
    MetricTons: 4
}

export const VpsTemperatureUnit =
{
    Celcius: 1,
    Fahrenheit: 2
}

export const VpsPressureUnit =
{
    kPa: 1,
    Bar: 2,
    Psi: 3
}

export const VpsViscosityUnit =
{
    KinVisc_50C: 1,
    Engler: 2,
    RedWood1: 3,
    SSF: 4,
    SSU_122F: 5,
    SSU_210F: 6
}

export const VpsFuelType =
{
    Residual: 1,
    Distillate: 2
}

export const VpsMethod =
{
    ISO2010: 1,
    ISO2005: 2,
    ASTM4868: 3,
    ISO1996: 4,
    ASTM240: 5,
    ISO4264: 6,
    ASTM976: 7
}

export const VpsCommodity =
{
    CrudeOil: 1,
    RefinedProduct: 2,
    LubricatingOil: 3
}

export const VpsFuel = {
    HeavyFuelOil: 1,
    DieselOrGasoil: 2,
    LightFuelOil: 3,
    LiquidPetroleumGas: 4,
    NaturalGas: 5
}

export const Approximates = (left, right, sigfigs = 15) => {
    
    if (left == right)
        return true;

    let sigValue;
    if (sigfigs == 15)
        sigValue = sigValue = 1.0E+15
    else
        sigValue = 10 ^ (sigfigs - 1)

    return Math.abs(left - right) < Math.abs(left / sigValue)
}

export const VerifyNumericLimit_ByLimit = (value, limitValue, minimumLimit) => {

    // let number;
    let number = {};
    // if (value.toString().trim().length == 0)
    //     return false;

    // number = parseFloat(value);

    if (value.toString().trim().length == 0 || !MathFormula.TryParseFloat(value, number))
        return false;
    else {
        let approximate = Approximates(number.value, limitValue);
        if (minimumLimit && (number.value < limitValue && !approximate))
            return false;
        if (!minimumLimit && (number.value > limitValue && !approximate))
            return false;
    }
    return true;
}


export const VerifyNumericLimit_Btw_MinMax = (value, minimumValue, maximumValue) => {
    
    let number = {};
    // if (value.toString().trim().length == 0)
    //     return false;

    // number = parseFloat(value);

    if (value.toString().trim().length == 0 || !MathFormula.TryParseFloat(value, number))
        return false;
    else {
        let approximateMin = Approximates(number.value, minimumValue);
        let approximateMax = Approximates(number.value, maximumValue);
        if ((number.value < minimumValue && !approximateMin) ||
            (number.value > maximumValue && !approximateMax))
            return false;
    }
    return true;
}

// CLng(1536.750) - 1537  Math.round(1536.750) - 1537
export const RoundValueASTM = (valueToRound, roundFormat) => {

    let decimalSymbol = ".";
    let normalizedValue = (Math.abs(valueToRound) / roundFormat);

    let decimalPosition = normalizedValue.toString().indexOf(decimalSymbol);

    if (decimalPosition > -1) {
        let decimalPart = normalizedValue.toString().substring(decimalPosition);
        let integerValue;
        if (decimalPart == 0.5) {
            if ((Math.sign(normalizedValue) * Math.floor(Math.abs(normalizedValue))) % 2 == 0) {
                integerValue = Math.round(Math.sign(normalizedValue) * Math.floor(Math.abs(normalizedValue)));
            }
            else {
                integerValue = Math.round(Math.sign(normalizedValue) * Math.floor(Math.abs(normalizedValue + 1)));
            }
        }
        else {
            integerValue = Math.round(Math.sign(normalizedValue) * Math.floor(Math.abs(normalizedValue + 0.5)));
        }

        let roundedValue = ((Math.sign(valueToRound) * integerValue * roundFormat));
        return roundedValue;
    }
    else {
        if (typeof valueToRound === "string") {
            valueToRound = Number(valueToRound)
        }
        let value = (valueToRound);
        return value;
    }
}

// VB: CInt(36.75) - 37  JS: Math.round(36.75) - 37
// Math.Sign -1( less than zero), 0(equal to zero), 1(greater than zero)
// Math.abs(-7.25) - 7.25
// VB: "test".PadRight(8, ".") -  test.... JS: "test".padEnd(8, '.')  -  test....
// VB: "Hello" & " World" - "Hello World" JS: `${var1}${var2}` - test test
export const RemoveScientificNotation = (number) => {
    try {
        let decimalSymbol = ".";
        let positionE = number.indexOf("E");
        let positionDecimal = number.indexOf(decimalSymbol);

        let powerOf10 = Math.round(number.substring(positionE + 1));

        let integerPart = "";
        let decimalPart = "";

        if (positionDecimal > -1) {
            integerPart = number.substring(0, positionDecimal);
            decimalPart = number.substring(positionDecimal + 1, positionE - positionDecimal - 1);
        }
        else
            integerPart = number.substring(0, positionE)

        if (integerPart.substring(0, 1) == "-")
            integerPart = integerPart.substring(1);

        let integerPartLength = integerPart.length;
        let decimalPartLength = decimalPart.length;

        let zerosToAdd = "";
        let convertedText = "";
        if (Math.sign(powerOf10) == -1) {
            powerOf10 = Math.abs(powerOf10);
            if (integerPartLength < powerOf10) {
                zerosToAdd = zerosToAdd.padEnd(powerOf10 - integerPartLength, "0");
                convertedText = `${decimalSymbol}${zerosToAdd}${integerPart}${decimalPart}`;
            }
            else {
                convertedText = `${integerPart.substring(0, integerPartLength - powerOf10)}_${decimalSymbol}${integerPart.substring(integerPartLength - powerOf10)}${decimalPart}`;
            }
        }
        else {
            if (integerPart.length > 0)
                convertedText = integerPart
            if (decimalPart.length < powerOf10) {
                zerosToAdd = zerosToAdd.padEnd(powerOf10 - decimalPartLength, "0");
                convertedText = `${convertedText}${decimalPart}${zerosToAdd}`;
            }
            else
                convertedText = `${convertedText}${decimalPart.substring(0, powerOf10)}`;
            if (decimalPartLength - powerOf10 > 0) {
                convertedText = `${convertedText}${decimalSymbol}_${decimalPart.Substring(powerOf10, decimalPartLength - powerOf10)}`;
            }
        }

        if (convertedText.substring(0, 1) == decimalSymbol)
            convertedText = `0${convertedText}`;

        if (number < 0)
            convertedText = `-${convertedText}`;

        return convertedText;
    }
    catch (ex) {
        return "";
    }

}

// Todo: format string
export const RoundValueASTM_ValAsStr = (valueToRound, roundFormat) => {

    let roundingText = roundFormat.toString();
    let decimalSymbol = ".";
    let formattingString = "0";
    let decPlaces = 0;
    let value = parseFloat(valueToRound);
    let result = {};

    if (MathFormula.TryParseFloat(valueToRound, result)) {
        result.value = RoundValueASTM(result.value, roundFormat);

        if (roundingText.indexOf("E") > -1) {
            roundingText = RemoveScientificNotation(roundingText)
        }

        if (roundingText.indexOf(decimalSymbol) > -1)
            decPlaces = roundingText.length - (roundingText.indexOf(decimalSymbol) + 1)

        if (decPlaces > 0)
            formattingString = `${formattingString}.${formattingString.padEnd(decPlaces, "0")}`;

        //return result.value.toString(formattingString)
        return result.value.toString();
    }

    return "0";
}

// "   test    ".trim() - "test" 
export const GetDecimalsFromString = (text) => {

    let number = {};

    if (MathFormula.TryParseFloat(text, number)) {
        let decimalSymbol = ".";
        let pos = text.indexOf(decimalSymbol);
        if (pos > -1)
            return text.toString().trim().length - 1 - pos;
        else
            return 0;
    }
    else
        return -1;
}